import { z } from 'zod';
import { defineEndpoint } from '../define';
import { ReleaseEnvironmentSchema } from './shapes';

/**
 * Tester groups for one channel (UCH-513) — the options-only source for every
 * group picker. Served from the channel's synced cache (lazy-filled from the
 * Firebase App Distribution API on first read); the product-config Sync button
 * refreshes it.
 */
export const FadTesterGroupSchema = z.object({
  alias: z.string(),
  displayName: z.string(),
});
export type FadTesterGroup = z.infer<typeof FadTesterGroupSchema>;

const FadGroupsResponseSchema = z.object({
  data: z.object({
    groups: z.array(FadTesterGroupSchema),
    /** Last sync with FAD; null only when the cache has never been filled. */
    syncedAt: z.string().nullable(),
  }),
});

export const listFadTesterGroups = defineEndpoint({
  method: 'GET',
  path: '/v1/release-products/:productId/channels/:environment/fad-groups',
  params: z.object({ productId: z.string().uuid(), environment: ReleaseEnvironmentSchema }),
  query: z.object({}),
  body: z.undefined(),
  response: FadGroupsResponseSchema,
});

/** Force-refresh the cache from FAD (product-config Sync button). */
export const syncFadTesterGroups = defineEndpoint({
  method: 'POST',
  path: '/v1/release-products/:productId/channels/:environment/fad-groups/sync',
  params: z.object({ productId: z.string().uuid(), environment: ReleaseEnvironmentSchema }),
  query: z.object({}),
  body: z.undefined(),
  response: FadGroupsResponseSchema,
});
